export type BaseURLType = {
  ID: string;
  ID_BASE_URL: string;
  NUT_BASE_URL: string;
  PLATFORM_BASE_URL: string;
  PNOE_API_BASE_URL: string;
  PNOE_API_AGENT_URL: string;
  BREATH_API_BASE_URL: string;
};

export type ConfigType = {
  DEV: BaseURLType;
  PROD: BaseURLType;
  LOCAL: BaseURLType;
};

const CONFIG: ConfigType = {
  DEV: {
    ID: "dev",
    ID_BASE_URL: "https://id-dev.mypnoe.com/",
    NUT_BASE_URL: "https://nut-dev.mypnoe.com/",
    PLATFORM_BASE_URL: "https://pnoeapi-dev.mypnoe.com/",
    PNOE_API_BASE_URL: "https://api-dev.mypnoe.com/",
    PNOE_API_AGENT_URL: "https://pnoeagentapi-dev.azurewebsites.net/",
    BREATH_API_BASE_URL: "https://breath-data-api-dev.mypnoe.com/",
  },
  PROD: {
    ID: "prod",
    ID_BASE_URL: "https://id.mypnoe.com/",
    NUT_BASE_URL: "https://nut.mypnoe.com/",
    PLATFORM_BASE_URL: "https://pnoeapi.mypnoe.com/",
    PNOE_API_BASE_URL: "https://api.mypnoe.com/",
    PNOE_API_AGENT_URL: "https://pnoeagentapi.azurewebsites.net/",
    // TODO(backend): confirm the production hostname for the Breath Data API.
    BREATH_API_BASE_URL: "https://breath-data-api.mypnoe.com/",
  },
  LOCAL: {
    ID: "local",
    ID_BASE_URL: "https://id-dev.mypnoe.com/",
    NUT_BASE_URL: "https://nut-go.ngrok.io/",
    PLATFORM_BASE_URL: "https://pnoeapi.mypnoe.com/",
    PNOE_API_BASE_URL: "https://api-dev.mypnoe.com/",
    PNOE_API_AGENT_URL: "https://pnoeagentapi.azurewebsites.net/",
    // Local development points at dev, unlike PLATFORM_BASE_URL above.
    BREATH_API_BASE_URL: "https://breath-data-api-dev.mypnoe.com/",
  },
};

export default CONFIG;
